<template>
  <v-card v-bind:style="{ backgroundColor: cor, color: cor}">
    <div class="color"></div>
  </v-card>
</template>

<script>
export default {
  props: ['cor'],
};
</script>

<style>
.color {
  height: 50px;
  width: 50px;
}
</style>
